import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  NgModule,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {QuantityModule} from '../quantity/quantity.component';
import {FilterByPipe, NgArrayPipesModule} from 'ngx-pipes';
import {combineLatest, Observable, ReplaySubject} from 'rxjs';
import {distinctUntilChanged, map, shareReplay} from 'rxjs/operators';
import {ShopService} from '../../services/shop.service';
import {CartMode} from '../../model/cart-modes';
import {
  CART_MODE,
  CART_PRODUCTS,
  CART_PRODUCTS_QUANTITY,
  CART_PROVIDERS,
  ProductsQuantity
} from '../../providers/cart.providers';
import {CartProduct} from '../../snipcart/product/product.reducer';
import {ProductService} from './product.service';
import {TranslocoModule} from '@ngneat/transloco';
import {CURRENT_ROUTED_PRODUCT} from '../../providers/route.providers';
import {Product, Variant} from '../../model/product';
import {IS_XS} from '../../providers/ui.providers';
import {ReactiveComponentModule} from '@ngrx/component';

@Component({
  selector: 'app-product-list-variant',
  templateUrl: './product-list-variant.component.html',
  styleUrls: ['./product-list-variant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [FilterByPipe, CART_PROVIDERS]
})
export class ProductListVariantComponent implements OnInit, AfterViewInit, OnChanges {

  @Input()
  price: string;

  @Input()
  listPrice: string;

  @Input()
  title: string;

  @Input()
  taxable: boolean;

  @Input()
  taxIncluded: boolean;

  @Input()
  available: boolean;

  @Input()
  showSeparator: boolean;

  @Input()
  resourceIdentifier: Variant;

  @Input()
  description;

  @Input()
  snipcartImageUrl: string;

  @Input()
  hasMoreVariants: boolean;

  resourceIdentifier$: ReplaySubject<Variant> = new ReplaySubject<Variant>(1);

  quantity$: Observable<number> = combineLatest([
    this.resourceIdentifier$,
    this.productsQuantity$,
    this.productService.isProductUnavailable$
  ]).pipe(
    map(([resourceIdentifier, productsQuantity, productUnavailable]: [Variant, ProductsQuantity, boolean]) => {
      let count: number;
      if (resourceIdentifier &&
        (productsQuantity[resourceIdentifier.id] || productsQuantity[resourceIdentifier.sku]) &&
        !productUnavailable) {
        count = productsQuantity[resourceIdentifier.id] || productsQuantity[resourceIdentifier.sku];
      } else if (!this.available || productUnavailable) {
        count = -1;
      } else {
        count = 0;
      }
      return count;
    }),
    shareReplay(1)
  );

  isProductContext$: Observable<boolean> = this.currentRoutedProduct$.pipe(
    map(product => !!product),
    distinctUntilChanged()
  );


  constructor(
    private renderer: Renderer2,
    private element: ElementRef,
    private filterByPipe: FilterByPipe,
    public shopService: ShopService,
    private productService: ProductService,
    @Inject(CART_MODE) readonly cartMode$: Observable<CartMode>,
    @Inject(CART_PRODUCTS) readonly cartProducts$: Observable<CartProduct[]>,
    @Inject(CART_PRODUCTS_QUANTITY) readonly productsQuantity$: Observable<ProductsQuantity>,
    @Inject(CURRENT_ROUTED_PRODUCT) readonly currentRoutedProduct$: Observable<Product>,
    @Inject(IS_XS) readonly isXs$: Observable<boolean>
  ) {
  }

  ngOnInit(): void {

    if (this.showSeparator === true) {
      this.renderer.addClass(this.element.nativeElement, 'show-separator');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'show-separator');
    }

    this.productService.description = this.description;
    this.productService.snipcartImageUrl = this.snipcartImageUrl;

  }

  ngAfterViewInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.resourceIdentifier.previousValue?.id !== changes.resourceIdentifier.currentValue?.id) {
      this.resourceIdentifier$.next(this.resourceIdentifier);
    }
  }

}

@NgModule({
  declarations: [
    ProductListVariantComponent
  ],
  imports: [
    CommonModule,
    QuantityModule,
    NgArrayPipesModule,
    TranslocoModule,
    ReactiveComponentModule
  ],
  exports: [
    ProductListVariantComponent
  ],
  entryComponents: []
})

export class ProductListVariantModule {
}
